// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2DOew","header":"ReportDetails_header__GaIaY","title":"ReportDetails_title__2ICMK","left":"ReportDetails_left__2U8Ca"};